export const baseDevelopmentURL = "https://joincissa-backend.herokuapp.com/api";
// export const baseDevelopmentURL = "http://localhost:3050/api";
export const LOGIN = "LOGIN";
export const SIGNUP = "SIGNUP";
export const VERIFICATION = "VERIFICATION";
